import React from 'react';
import { connect } from 'react-redux';
import { PatientDot } from '_components';
import { getApptStatusIndicator } from '_helpers';
import styles from './Appointment.module.css';


class PatientCareCenterNoteMiniScheduleAppointment extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            seconds: 0
        };
    }

    tick() {
        this.setState(state => ({
            seconds: state.seconds + 10
        }));
    }

    componentDidMount() {
        if (this.props.appt.ADTASID === 1) {
            this.interval = setInterval(() => this.tick(), 10000);
        }
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        return (
            <div className={styles.wrapper}>
                <span className={styles.col1}>
                    {getApptStatusIndicator(this.props.appt.NSNO, this.props.appt.ADTASID, this.props.date, this.props.appt.APTSTART)}
                </span>
                <span className={styles.col2}>
                    <PatientDot id={this.props.appt.DOT} />
                </span>
                <span
                    className={styles.col3}
                    title={this.props.appt.PTFNAME + ' ' + this.props.appt.PTLNAME + ' ' + this.props.appt.APTSTARTTEXT + ' - ' + this.props.appt.APTENDTEXT}
                >
                    {this.props.appt.PTFNAME + ' ' + this.props.appt.PTLNAME}
                </span>
            </div>
        );
    }

}

function mapStateToProps(state, ownprops) {
    return {
        appt: state.entities.dashboard.todaysSchedule[ownprops.id],
        date: new Date().setHours(0, 0, 0, 0)
    };
}

const connectedPatientCareCenterNoteMiniScheduleAppointment = connect(mapStateToProps)(PatientCareCenterNoteMiniScheduleAppointment);
export { connectedPatientCareCenterNoteMiniScheduleAppointment as PatientCareCenterNoteMiniScheduleAppointment };

